var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-toolbar",
                { attrs: { color: "primary", dark: "" } },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$route.params.customer) + " Customer Details"
                    )
                  ]),
                  _c("v-spacer"),
                  _c("v-icon", [_vm._v("mdi-account-box-multiple")])
                ],
                1
              ),
              _vm._l(_vm.custPostErrors, function(item, index) {
                return _c(
                  "v-alert",
                  {
                    key: index,
                    staticClass: "mt-2",
                    attrs: { type: "error", dismissible: "" }
                  },
                  [
                    _c("span", { staticClass: "text-uppercase" }, [
                      _vm._v(_vm._s(item.first()))
                    ])
                  ]
                )
              })
            ],
            2
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Product Category",
                  items: _vm.prdCatList,
                  loading: _vm.prdCatGetting,
                  "item-value": "id"
                },
                scopedSlots: _vm._u([
                  {
                    key: "selection",
                    fn: function({ item }) {
                      return [
                        _c("span", { staticClass: "primary--text" }, [
                          _vm._v(_vm._s(item.id))
                        ]),
                        _c(
                          "span",
                          { staticClass: "blue-grey--text mx-1 text-caption" },
                          [_vm._v(_vm._s(item.name))]
                        )
                      ]
                    }
                  },
                  {
                    key: "item",
                    fn: function({ item }) {
                      return [
                        _c("span", { staticClass: "primary--text" }, [
                          _vm._v(_vm._s(item.id))
                        ]),
                        _c(
                          "span",
                          { staticClass: "blue-grey--text mx-1 text-caption" },
                          [_vm._v(_vm._s(item.name))]
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.productCategoryId,
                  callback: function($$v) {
                    _vm.productCategoryId = $$v
                  },
                  expression: "productCategoryId"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Capacity",
                  type: "number",
                  loading: _vm.custDetGetting
                },
                model: {
                  value: _vm.capacity,
                  callback: function($$v) {
                    _vm.capacity = $$v
                  },
                  expression: "capacity"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "Capacity Unit", loading: _vm.custDetGetting },
                model: {
                  value: _vm.capacityUnit,
                  callback: function($$v) {
                    _vm.capacityUnit = $$v
                  },
                  expression: "capacityUnit"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "EX Supplier", loading: _vm.custDetGetting },
                model: {
                  value: _vm.exSupplier,
                  callback: function($$v) {
                    _vm.exSupplier = $$v
                  },
                  expression: "exSupplier"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "Potential", loading: _vm.custDetGetting },
                model: {
                  value: _vm.potential,
                  callback: function($$v) {
                    _vm.potential = $$v
                  },
                  expression: "potential"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", cols: "12" } },
            [
              _c("v-checkbox", {
                attrs: { loading: _vm.custDetGetting, label: "Confirmed" },
                model: {
                  value: _vm.confirmed,
                  callback: function($$v) {
                    _vm.confirmed = $$v
                  },
                  expression: "confirmed"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Date Start",
                  type: "date",
                  loading: _vm.custDetGetting
                },
                model: {
                  value: _vm.dateStart,
                  callback: function($$v) {
                    _vm.dateStart = $$v
                  },
                  expression: "dateStart"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "1", cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    loading: _vm.custPosting,
                    block: "",
                    dark: ""
                  },
                  on: { click: _vm.storeCustDet }
                },
                [_vm._v("Save")]
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "1", cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "red", block: "", dark: "" },
                  on: {
                    click: function($event) {
                      return _vm.$router.push("/customers")
                    }
                  }
                },
                [_vm._v("Cancel")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }